/*
  src/redux/entities/reducer.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import update from '../update';
import { asObject, batchUpdateAsObjects } from '../../../shared/utils';

import {
  LIST_LOADED,
  ENTITY_LOADED,
  ACTIVE_USER_LOADED,
  IMPERSONATED_USER_LOADED,
  ENTITY_UPDATE_REQUESTED,
  ENGAGEMENT_SORT_ORDER_UPDATE_REQUESTED,
  ENTITY_CREATED,
  ENTITY_DELETE_REQUESTED,
  ENGAGEMENT_OPTION_CREATED,
  ENGAGEMENT_OPTION_UPDATE_REQUESTED,
  ENGAGEMENT_OPTION_DELETE_REQUESTED,
  LOYALTY_BALANCE_LOADED,
  ENGAGEMENT_OPTIONS_UPDATE_REQUESTED,
  ENTITY_DUPLICATED,
  ENTITY_BATCH_LOADED,
  ENTITY_PUBLISHERS_UPDATE_REQUESTED,
  ENTITY_PUBLISHERS_UPDATED,
  ENTITY_TAGS_SYNCED,
  ENTITY_HISTORY_LOADED,
  ENTITY_GEOFILTER_SYNCED,
  ENTITY_CONSTRAINTS_SYNCED
} from './constants';

const initialState = {
  activeUserId:null,
  impersonatedUserId:null,
  agencies:{},
  users:{},
  appUsers:{},
  appAssets:{},
  campaigns:{},
  engagements:{},
  companies:{},
  segmentations:{},
  paymentMethods: {},
  tagVendors: {},
};



export default function(state = initialState, action){
  switch(action.type){

  case LIST_LOADED:
    return update(state,{
      [action.payload.collection]:{
        $deepMerge:asObject(action.payload.instances)
      }
    });

  case ENTITY_LOADED:
    return update(state,{
      [action.payload.collection]:{
        $deepMerge:{
          [action.payload.instance.id]:action.payload.instance
        }
      }
    });

  case ACTIVE_USER_LOADED:
    return update(state,{
      [action.payload.collection]:{
        $deepMerge:{
          [action.payload.instance.id]:action.payload.instance
        }
      },
      activeUserId:{
        $set:action.payload.instance.id
      }
    });

    case IMPERSONATED_USER_LOADED:
      return update(state,{
        [action.payload.collection]:{
          $deepMerge:{
            [action.payload.instance.id]:action.payload.instance
          }
        },
        impersonatedUserId:{
          $set:action.payload.instance.id
        }
      });

  case ENTITY_UPDATE_REQUESTED:
    return update(state,{
      [action.payload.collection]:{
        $deepMerge:{
          [action.payload.instance]:action.payload.update
        }
      }
    });

  case ENTITY_DUPLICATED:
    return update(state,{
      [action.payload.collection]:{
        $deepMerge:{
          [action.payload.instance.id]:action.payload.instance
        }
      }
    })

  case ENTITY_CREATED:
    return update(state,{
      [action.payload.collection]:{
        $deepMerge:{
          [action.payload.instance.id]:action.payload.instance
        }
      }
    });

  case ENTITY_DELETE_REQUESTED:
    return update(state,{
      [action.payload.collection]:{
        $delete:action.payload.instance.id
      }
    });

  case ENGAGEMENT_SORT_ORDER_UPDATE_REQUESTED:
    return update(state,{
      [action.payload.collection]:{
        $deepMerge:asObject(action.payload.instances)
      }
    });

  case ENGAGEMENT_OPTION_CREATED:
    return update(state,{
      engagements:{
        [action.payload.instance.parentId]:{
          options:{
            $push:[action.payload.instance]
          }
        }
      }
    });

  case ENGAGEMENT_OPTION_UPDATE_REQUESTED:
    return update(state,{
      engagements:{
        [action.payload.instance.parentId]:{
          options:{
            $apply:(options) => options.map((option) => {
              if(option.id !== action.payload.instance.id) return option;
              return {...option, ...action.payload.instance.update};
            })
          }
        }
      }
    });

  case ENGAGEMENT_OPTION_DELETE_REQUESTED:
    return update(state,{
      engagements:{
        [action.payload.instance.parentId]:{
          options:{
            $apply:(options) => options.filter((option) => option.id !== action.payload.instance.id)
          }
        }
      }
    });

  case ENGAGEMENT_OPTIONS_UPDATE_REQUESTED:
    return update(state,{
      engagements:{
        [action.payload.instances[0].parentId]:{
          options:{
            $set:action.payload.instances
          }
        }
      }
    });

  case LOYALTY_BALANCE_LOADED:
    return update(state,{
      appUsers:{
        [action.payload.customerId]:{
          $deepMerge:{
            loyaltyBalance:parseFloat(action.payload.balance),
            loyaltyBuffer:parseFloat(action.payload.buffer)
          }
        }
      }
    });

  case ENTITY_BATCH_LOADED:
    return update(state,{
      $deepMerge:batchUpdateAsObjects(action.payload)
    });

  case ENTITY_PUBLISHERS_UPDATE_REQUESTED:
    return update(state,{
      [action.payload.collection]:{
        [action.payload.instance]:{
          publisherIds:{
            $set:action.payload.update.publisherIds
          }
        }
      }
    });

  case ENTITY_PUBLISHERS_UPDATED:
    return update(state,{
      [action.payload.collection]:{
        [action.payload.instance]:{
          publisherIds:{
            $set:action.payload.update.publisherIds
          }
        }
      }
    });

  case ENTITY_TAGS_SYNCED:
    return update(state,{
      [action.payload.collection]:{
        [action.payload.instance]:{
          tags:{
            $set:action.payload.update.tags
          }
        }
      }
    });

  case ENTITY_GEOFILTER_SYNCED:
    return update(state,{
      [action.payload.collection]:{
        [action.payload.instance]:{
          geoFilterPredicate:{
            $set:action.payload.update.predicate
          },
          states:{
            $set:action.payload.update.states
          },
          reach:{
            $set:action.payload.update.reach
          }
        }
      }
    })

  case ENTITY_CONSTRAINTS_SYNCED:
    console.log('PAYLOAD -> ',action.payload);
    return update(state,{
      [action.payload.collection]:{
        [action.payload.instance]:{
          geoFilterPredicate:{
            $set:action.payload.update.predicate
          },
          states:{
            $set:action.payload.update.filters
          },
          constraints:{
            $set:action.payload.update.constraints
          },
          reach:{
            $set:action.payload.update.reach
          }
        }
      }
    })

  case ENTITY_HISTORY_LOADED:
    return update(state,{
      [action.payload.collection]:{
        [action.payload.instance]:{
          history:{
            $set:action.payload.update.history
          }
        }
      }
    })

  default:
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/entities/reducer.js